webpackJsonp([45],{

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(19);





var checkout = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
		var body, url, _ref2, res;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						body = {
							orderId: this.getOrderId,
							commerceCode: '5wwfh1',
							ipAddress: this.ipAddress
						};
						url = 'payment-gateway/niubiz/checkout';
						_context.next = 4;
						return this.$httpSales.post(url, body);

					case 4:
						_ref2 = _context.sent;
						res = _ref2.data;

						this.merchantId = res.merchantId;
						this.sessionKey = res.sessionKey;
						this.payboxProduction = res.payboxProduction;
						this.currency = res.currency;
						this.amount = res.amount;
						this.createScript();

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function checkout() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function createScript() {
	if (process.browser && this.merchantId) {
		var visaForm = document.createElement('script');
		var dataSessionToken = this.sessionKey;
		var dataMerchantId = this.merchantId;
		var dataAmount = this.amount;
		var dataCurrency = this.currency;
		var src = this.payboxProduction === 'dev' ? this.dev : this.prod;
		var purchaseNumber = this.getOrderId;
		var logo = this.getCommerceData.urlImage;
		var name = 'santamariastore';
		var btnColor = 'undefined';
		visaForm.setAttribute('src', src);
		visaForm.setAttribute('data-sessiontoken', dataSessionToken);
		visaForm.setAttribute('data-channel', 'web');
		visaForm.setAttribute('data-merchantid', dataMerchantId);
		visaForm.setAttribute('data-merchantlogo', logo);
		visaForm.setAttribute('data-merchantname', name);
		visaForm.setAttribute('data-formbuttoncolor', btnColor);
		visaForm.setAttribute('data-purchasenumber', purchaseNumber);
		visaForm.setAttribute('data-amount', dataAmount);
		visaForm.setAttribute('data-currency', dataCurrency);
		visaForm.setAttribute('currency', dataCurrency);
		visaForm.setAttribute('data-expirationminutes', 20);
		visaForm.setAttribute('data-timeouturl', 'timeout.html');
		var Visa = document.getElementById('visa-payment').appendChild(visaForm);
		Visa.onload = function () {
			var visaBtn = document.querySelector('.modal-opener');
			visaBtn.style.visibility = 'hidden';
			visaBtn.click();
		};
	}
}

function orderTotal() {
	return this.getTotalToBuy + this.getShippingCost;
}

function redirect() {
	var orderId = 'orderId=' + this.getOrderId;
	var successUri = 'uri=resumen-de-mi-pedido';
	var errorUri = 'errorUri=carrito-de-compras/pago/' + this.getOrderId;
	var base = (this.apiSales || '').endsWith('/') ? this.apiSales.slice(0, -1) : this.apiSales;
	return base + '/payment-gateway/validation?' + orderId + '&' + successUri + '&' + errorUri;
}

function conditionsAndTermsLink() {
	var _this = this;

	var findIt = this.help.find(function (h) {
		var name = _this.normalize(h.name);
		return name === 'terminos y condiciones';
	});

	var _findIt$section = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(findIt.section, 1),
	    item = _findIt$section[0];

	var link = findIt;
	var newItem = item.name.split(' ').join('-');
	var newLink = link.name.split(' ').join('-');
	this.$router.push('/ayuda/apartado/' + newItem + '/seccion/' + newLink);
}

function normalize(str) {
	return str.toLowerCase().normalize('NFD').replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi, '$1$2').normalize();
}

function data() {
	return {
		amount: 0,
		apiSales: 'https://cm-sales.apprunn.net',
		companyLogo: 'undefined',
		checkbox: false,
		currency: 'PEN',
		dev: 'https://static-content-qas.vnforapps.com/v2/js/checkout.js?qa=true',
		expirationTime: null,
		loading: false,
		merchantId: '',
		payboxProduction: false,
		prod: 'https://static-content.vnforapps.com/v2/js/checkout.js',
		sessionKey: null,
		totalAmount: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'niubiz',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['getOrderId', 'getShippingCost', 'getTotalToBuy', 'token', 'getCommerceData']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])({
		help: function help(state) {
			return state.commerce.helperCenter;
		}
	}), {
		orderTotal: orderTotal,
		redirect: redirect
	}),
	data: data,
	methods: {
		checkout: checkout,
		conditionsAndTermsLink: conditionsAndTermsLink,
		createScript: createScript,
		normalize: normalize
	},
	props: {
		img: {
			required: true,
			type: String
		},
		ipAddress: {
			required: true,
			type: String
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(138)))

/***/ }),

/***/ 1244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_niubiz_vue__ = __webpack_require__(1052);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e629be5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_niubiz_vue__ = __webpack_require__(1247);
function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e629be5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_niubiz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e629be5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_niubiz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1246);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(784)("f52c3f98", content, true, {});

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(783)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Avenir Next Regular;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Bold;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Book;font-style:normal;font-weight:400;src:local(\"Avenir Next Book\",url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))}.start-js-btn.modal-opener.default[data-v-e629be5e]{background:url(\"/static/img/icons/icon-visanet.png\")!important}#visa-payment[data-v-e629be5e]{width:656px}@media (max-width:768px){#visa-payment[data-v-e629be5e]{width:auto}}.niubiz-btn[data-v-e629be5e]{border:1px solid #000;display:-webkit-box;display:-ms-flexbox;display:flex;height:50px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:auto 1rem;padding:0 2rem;-webkit-transition-duration:.25s;transition-duration:.25s}.niubiz-btn[data-v-e629be5e]:hover{-webkit-box-shadow:0 25px 50px -12px rgba(0,0,0,.25);box-shadow:0 25px 50px -12px rgba(0,0,0,.25);-webkit-transform:scale(1.05);transform:scale(1.05)}.niubiz-btn[disabled][data-v-e629be5e]{opacity:.3;cursor:not-allowed}.conditions[data-v-e629be5e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.conditions .check[data-v-e629be5e]{margin-right:1rem;max-width:2rem}.conditions button[data-v-e629be5e]{color:#006edb;text-decoration:underline}", "", {"version":3,"sources":["/opt/build/repo/src/components/order/paymentsMethods/niubiz.vue"],"names":[],"mappings":"AACA,WACE,gCAAmC,AACnC,kBAAmB,AACnB,gBAAoB,AACpB,wGAA2G,CAC5G,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,0GAA6G,CAC9G,AACD,WACE,2CAA8C,AAC9C,kBAAmB,AACnB,gBAAoB,AACpB,mHAAsH,CACvH,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kHAAqH,CACtH,AACD,WACE,sCAAyC,AACzC,kBAAmB,AACnB,gBAAoB,AACpB,+GAAkH,CACnH,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,2GAA8G,CAC/G,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,8BAAiC,AACjC,kBAAmB,AACnB,gBAAoB,AACpB,mGAAsG,CACvG,AACD,WACE,qCAAwC,AACxC,kBAAmB,AACnB,gBAAoB,AACpB,6GAAgH,CACjH,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kFAAqF,CACtF,AACD,oDACE,8DAAiE,CAClE,AACD,+BACE,WAAa,CACd,AACD,yBACA,+BACM,UAAY,CACjB,CACA,AACD,6BACE,sBAAwB,AACxB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAkB,AAClB,eAAgB,AAChB,iCAAmC,AAC3B,wBAA2B,CACpC,AACD,mCACI,qDAA0D,AAClD,6CAAkD,AAC1D,8BAA+B,AACvB,qBAAuB,CAClC,AACD,uCACI,WAAa,AACb,kBAAoB,CACvB,AACD,6BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,oCACI,kBAAmB,AACnB,cAAgB,CACnB,AACD,oCACI,cAAe,AACf,yBAA2B,CAC9B","file":"niubiz.vue","sourcesContent":["\n@font-face {\n  font-family: \"Avenir Next Regular\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Regular\"), url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Italic\"), url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Ultra Light\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light\"), url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Ultra Light Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light Italic\"), url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Medium\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Condensed\"), url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Medium Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Italic\"), url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Demi Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Demi Italic\"), url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Bold\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Bold\"), url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Heavy\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy\"), url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Heavy Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy Italic\"), url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Book\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next Book\", url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"));\n}\n.start-js-btn.modal-opener.default[data-v-e629be5e] {\n  background: url(\"/static/img/icons/icon-visanet.png\") !important;\n}\n#visa-payment[data-v-e629be5e] {\n  width: 656px;\n}\n@media (max-width: 768px) {\n#visa-payment[data-v-e629be5e] {\n      width: auto;\n}\n}\n.niubiz-btn[data-v-e629be5e] {\n  border: 1px solid black;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 50px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: auto 1rem;\n  padding: 0 2rem;\n  -webkit-transition-duration: 250ms;\n          transition-duration: 250ms;\n}\n.niubiz-btn[data-v-e629be5e]:hover {\n    -webkit-box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05);\n}\n.niubiz-btn[disabled][data-v-e629be5e] {\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n.conditions[data-v-e629be5e] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.conditions .check[data-v-e629be5e] {\n    margin-right: 1rem;\n    max-width: 2rem;\n}\n.conditions button[data-v-e629be5e] {\n    color: #006edb;\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"conditions"},[_c('v-checkbox',{staticClass:"check",attrs:{"data-cy":"niubiz-check"},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}}),_vm._v(" "),_c('span',[_vm._v("Acepto los\n\t\t\t"),_c('button',{attrs:{"type":"button"},on:{"click":_vm.conditionsAndTermsLink}},[_vm._v("\n\t\t\t\ttérminos y condiciones\n\t\t\t")])])],1),_vm._v(" "),_c('button',{staticClass:"niubiz-btn",staticStyle:{"padding":"1rem"},attrs:{"type":"button","data-cy":"niubiz-btn","disabled":!_vm.checkbox},on:{"click":_vm.checkout}},[_c('img',{attrs:{"src":_vm.img,"alt":"logo_Niubiz"}})]),_vm._v(" "),_c('form',{attrs:{"id":"visa-payment","action":_vm.redirect,"method":"post"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/45.f842016ac1520821f8eb.js